module.exports = __webpack_public_path__ + "img/check-circle-s.e2f9dbb1.svg";